import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

/**
 * @param {import('react-select').SingleValueProps} props
 */
function SingleValue(props) {
  return /*#__PURE__*/React.createElement(components.SingleValue, props, /*#__PURE__*/React.createElement("span", {
    className: props.selectProps.classNamePrefix + '__single-value-span'
  }, props.children));
}
SingleValue.propTypes = {
  selectProps: PropTypes.object,
  children: PropTypes.node
};
export default SingleValue;